import { CellClassParams, GridOptions } from 'ag-grid-community';
import React, { ComponentType, FC } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import styled from 'styled-components';

export const withPrivateTaskRow = <
  T extends Pick<GridOptions, 'getRowClass' | 'rowClassRules'>,
>(
  Component: ComponentType<T>,
): FC<Omit<T, 'getRowClass'>> => {
  const rowClassRules = {
    'task-grid-row-private': function (params: CellClassParams) {
      return params.data?.private;
    },
  };
  const StyledComponent = setDisplayName(
    wrapDisplayName(Component, 'WithPrivateTaskRowStyles'),
  )(styled(Component)`
    .task-grid-row-private {
      --ag-odd-row-background-color: var(--private-01);
      --ag-background-color: var(--private-01);
      --ag-row-hover-color: var(--private-02);
    }
  `);

  const Next: FC<Omit<T, 'getRowClass'>> = (props) => {
    const { rowClassRules: propsRowClassRules = {} } = props;

    return (
      <StyledComponent
        {...(props as any)}
        rowClassRules={{ ...rowClassRules, ...propsRowClassRules }}
      />
    );
  };

  return setDisplayName(wrapDisplayName(StyledComponent, 'WithPrivateTaskRow'))(
    Next,
  );
};
